<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="自定义字段"
        width="900px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap">
            <div class="left-con fl">
                <div>
                    <div>
                        <el-checkbox :indeterminate="checkAllIndeterminate" v-model="isCheckAll" @change="checkAllChange">全选</el-checkbox>
                    </div>
                    <div class="group-item-1 ml20" v-for="group1 in configData" :key="group1.id">
                        <div class="group-title mt10 mb10">
                            <el-checkbox
                                :indeterminate="group1.indeterminate"
                                :disabled="group1.disabled"
                                v-model="group1.checked"
                                @change="handleCheck(group1.id, $event)">
                                <span>{{group1.display_name}}</span>
                            </el-checkbox>
                        </div>
                        <div class="group-content">
                            <template v-for="group2 in group1.children">
                                <div class="test222 ml20" v-if="group2.children&&group2.children.length>1">
                                    <div class="group-title mt10 mb10">
                                        <el-checkbox
                                            :indeterminate="group2.indeterminate"
                                            :disabled="group2.disabled||isView"
                                            v-model="group2.checked"
                                            @change="handleCheck(group2.id, $event)">
                                            <span>{{group2.display_name}}</span>
                                        </el-checkbox>
                                    </div>
                                </div>
                                <el-checkbox
                                    class=" mb6 child-item"
                                    v-else
                                    :indeterminate="group2.indeterminate"
                                    :disabled="group2.disabled"
                                    v-model="group2.checked"
                                    @change="handleCheck(group2.id, $event)">
                                    <span>{{group2.display_name}}</span>
                                </el-checkbox>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-con fl">
                <div class="right-top relative">
                    已选 <span class="text-color-primary">{{checkedList.length}}</span> 个字段
                    <span class="clear-all-btn text-color-error pointer" @click="clearAll">清除全部</span>
                </div>
                <div class="right-bottom">
                    <div class="p6">
                        <draggable :list="checkedList" ghost-class="drag-ghost" group="field">
                            <p class="filter-item-field" v-for="item in checkedList" :key="item.id">
                                <el-tag size="small" type="info" class="tag-item ellipsis relative" :title="item.display_name">
                                    <span class="el-icon-rank mr10"></span>{{item.display_name}}
                                    <span v-if="!item.disabled" class="remove-btn text-color-error" title="删除" @click="removeField(item)">x</span>
                                </el-tag>
                            </p>
                        </draggable>

                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import util from '@/libs/utils';
    import API from '@/api/dataCenter/appKpi.js';
    import Draggable from 'vuedraggable';
    export default {
        name: "CustomFieldModal",
        props:{
            config:Array,
            selectList:Array,
            fieldType:String,
        },
        components:{
            Draggable,
        },
        data(){
            return {
                dialogVisible:false,
                configData:[],
                checkedList:[],
                submitLoading:false,
                isCheckAll:false,
                checkAllIndeterminate:true,
            }
        },
        computed:{
            allFields(){
                let list = [];
                this.configData.forEach(item=>{
                    list = list.concat(item.children||[]);
                });
                return list;
            },
        },
        methods:{
            showModal(){
                this.dialogVisible = true;
                this.configData = this._fmtTreeData(util.deepClone(this.config));
                this.checkedList = (this.selectList||[]).map(item=>{
                    let actionItem = this.allFields.find(field=>field.id==item)||{};
                    return {
                        id:item,
                        display_name:actionItem.display_name,
                        disabled:actionItem.disabled,
                    }
                });
                this.updateAllSelectStatus();
            },
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm() {
                this.configData = [];
                this.checkedList = [];
                this.isCheckAll = false;
                this.checkAllIndeterminate = true;
            },
            handleSubmit(){
                this.submitLoading = true;
                API.setCustomField({
                    field_type:this.fieldType,
                    fields:this.checkedList.map(item=>item.id),
                }).then(()=>{
                    this.$emit('save',this.checkedList);
                    this.dialogVisible = false;
                    this.submitLoading = false;
                },err=>{
                    console.log('setCustomField err',err);
                    this.$message.error(err.info||'请求失败');
                    this.submitLoading = false;
                });
            },
            handleCheck(id,val){
                let targetItem = this._findModuleById(this.configData, id);
                /*根节点：没有父级*/
                let isRoot = !this._findModuleById(this.configData,targetItem.pid);

                /* 叶节点：没有children为叶节点 */
                let isLeaf = !targetItem.children||((targetItem.children||[]).length<=0);

                if(isLeaf){
                    this.$set(targetItem,'checked',val);
                    let parentItem = this._findModuleById(this.configData, targetItem.pid);
                    parentItem.checked = (parentItem.children||[]).every(item=>item.checked);

                    let childLen = (parentItem.children||[]).length;
                    let checkedLen = (parentItem.children||[]).filter(item=>item.checked).length;
                    this.$set(parentItem,'indeterminate', checkedLen > 0 && checkedLen < childLen);


                    let checkedIndex = this.checkedList.findIndex(item=>item.id==id);
                    if(val){
                        if(checkedIndex<0){
                            this.checkedList.push(targetItem);
                        }
                    }else{
                        if(checkedIndex>=0){
                            this.checkedList.splice(checkedIndex,1);
                        }
                    }
                }else if(isRoot){

                    let childItem = targetItem.children||[];
                    childItem.forEach(child=>{
                        if(!child.disabled){
                            this.$set(child,'checked',val);
                        }else if(val){
                            this.$set(child,'checked',val);
                        }
                    });

                    childItem.forEach(child=>{
                        let checkedIndex = this.checkedList.findIndex(item=>item.id==child.id);
                        if(val){
                            if(checkedIndex<0&&!child.disabled){
                                this.checkedList.push(child);
                            }
                        }else{
                            if(checkedIndex>=0&&!child.disabled){
                                this.checkedList.splice(checkedIndex,1);
                            }
                        }
                    });
                    let childLen = childItem.length;
                    let checkedLen = childItem.filter(item=>item.checked).length;
                    this.$set(targetItem,'indeterminate',checkedLen > 0 && checkedLen < childLen);

                    if(childItem.every(item=>item.disabled)){
                        this.$set(targetItem,'checked',true);
                    }else{
                        this.$set(targetItem,'checked',val);
                    }
                }
                this.updateAllSelectStatus();
            },
            checkAllChange(val){
                this.checkAllIndeterminate = false;
                this.configData.forEach(item=>{
                    this.handleCheck(item.id,val,true);
                })
            },
            updateAllSelectStatus(){
                this.isCheckAll = this.allFields.every(item=>item.checked);
                this.checkAllIndeterminate = this.checkedList.length>0&&this.checkedList.length<this.allFields.length;
            },
            removeField(item){
                let actionItem = this.allFields.find(inner=>inner.id==item.id);
                if(actionItem.disabled)  return;
                this.handleCheck(item.id,false);
            },
            clearAll(){
                this.configData.forEach(group=>{
                    group.checked = false;
                    let children = group.children||[];
                    if(children.length>0){
                        children.forEach(child=>{
                            if(!child.disabled){
                                child.checked = false;
                            }
                        })
                    }
                    let checkedLen = children.filter(item=>item.checked).length;
                    group.indeterminate = checkedLen > 0 && checkedLen < children.length;
                });
                this.checkedList = this.allFields.filter(item=>item.disabled).map(item=>item);
            },
            _findModuleById(data, id) {
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _fmtTreeData(data){
                data.forEach((v) => {
                    let childFields = v.children||[];
                    let checkedLen = childFields.filter(item=>item.checked).length;
                    this.$set(v, 'indeterminate', checkedLen > 0 && checkedLen < childFields.length);
                    this.$set(v, 'checked', childFields.every(item=>item.checked));
                });
                return data;
            },
        }
    }
</script>

<style lang="scss" scoped>
.content-wrap{
    height: 360px;
    border: 1px solid #dcdee2;
    .left-con,.right-con{
        font-size: 12px;
        height: 100%;
    }
    .left-con{
        padding: 5px 10px;
        width: calc(100% - 200px);
        border-right: 1px solid #dcdee2;
        overflow-x: hidden;
        overflow-y: auto;

        .group-title ::v-deep .el-checkbox__label{
            font-weight: bold;
        }

        .group-content{
            margin-left: 40px;
        }

        .child-item{
            min-width: 175px;
            margin-right: 10px;
        }

    }
    .right-con{
        width: 200px;
        overflow-x: hidden;
        overflow-y: auto;

        .right-top{
            border-bottom: 1px solid #dcdee2;
            text-indent: 5px;
            height: 32px;
            line-height: 32px;
            .clear-all-btn{
                position: absolute;
                right: 5px;
                top: 0;
            }
        }
        .right-bottom{
            height: calc(100% - 32px);
            overflow-y: auto;

            .tag-item{
                width: 160px;
            }

            .remove-btn{
                position: absolute;
                right: 5px;
                top: 0;
                cursor: pointer;
                padding: 0 5px;
            }


            ::v-deep .drag-ghost .tag-item{
                border-color: #999!important;
                border-style: dashed!important;
                background-color: #ccc!important;
                position: relative;
            }

        }





    }
}
</style>
